import React from 'react';

import mixin from 'react-mixin';
import { changeDecimalString } from 'utils/formatting_utils';
import { getMobileDetect } from 'utils/dom_utils';

@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)

export default class InputDecimal extends React.Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.handleBlur = this.handleBlur.bind(this);
		this.position = null;
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ value: nextProps.value });
	}

	componentDidMount() {
		Materialize.updateTextFields();
		this.focusInputReadOnly();
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.warnings !== this.props.warnings && this.props.warnings) {
			$(`.tooltipped`).tooltip();
		}

		if (this.position !== null && this.position !== undefined) {
			const index = this.position;

			if ((this.refs.input.selectionStart - this.position) !== 1 && this.refs.input.selectionStart !== this.position && getMobileDetect() !== "iOS") {
				this.refs.input.setSelectionRange(index, index);
			}
        }
	}

	focusInputReadOnly(){
		let readOnly = this.props.readOnly;

		if(readOnly){
			let id = this.props.id;
			let input = $(`#${id}`);

			input.on('focus', () => {
				input.select();
			})
		}
	}

	getByLocale(prop) {
		if (prop === 'current')
			return Realize.i18n.currentLocale.toLowerCase();

		return Realize.i18n.t(`masks.decimal.${prop}`);
	}

	returnValue() {
		const { value } = this.state;
		return value;
	}

	handleChange(event) {
		const { maxLength, digits, component, prefix } = this.props;
		let value = event.target.value;
		const valueFormatted = changeDecimalString(value, maxLength, digits, component, prefix);
		const input = this.refs.input;
		const startStr = valueFormatted.substr(0, input.selectionStart - 1);

		if (prefix && startStr.indexOf(prefix) === -1) {
			this.position = input.selectionStart + (prefix ? prefix.length : 0);

			if (valueFormatted[this.position] === "." || valueFormatted[this.position] === ",")
				this.position = this.position + 1;
		}
		else {
			this.position = input.selectionStart;

			if (valueFormatted[this.position] === "." || valueFormatted[this.position] === ",")
				this.position = this.position + 1;
		}

		//manda pra api
		this.props.onChange(event, valueFormatted, this);

		//manda pra tela
		this.setState({ value: valueFormatted, changeValue: true });
	}

	handleBlur(event) {
		if (this.state.changeValue) {
			if (this.props.gridFormParent) {				
				Form.fields(this.props.gridFormParent).fields(this.props.id).warnings('').apply();
			}
			else {
				if (Form.fields(this.props.id)) {
					Form.fields(this.props.id).warnings('').apply();
				}
			}
		}
	}

	buildProps() {
		const props = Object.assign({}, this.props, {
			onChange: this.handleChange,
			onBlur: this.handleBlur,
			value: this.returnValue(),
			ref: "input",
			maxLength: null
		});

		return props;
	}

	classActionsAndWarnings(){
		const actionsFields = this.props.actions;
		const warningsFields = this.props.warnings;
		let className = '';

		if (actionsFields && actionsFields.length > 0)
			className += ' actions-field';

		if (warningsFields)
			className += ' warnings-field';

		return className;
	}

	renderInput(){
		return (
			<input {...this.buildProps()}
				placeholder={this.getPlaceholder()}
				className={this.inputClassName() + this.classActionsAndWarnings()}
				type={getMobileDetect() === "iOS" ? 'text' : 'tel'}
			/>
		);
	}

	render() {
		return this.renderInput();
	}
}
